import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/auth/login']);
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) return true;

  const user = auth.currentUser();
  if (user?.role === 'admin') {
    return router.createUrlTree(['/app/overview']);
  }

  // Stale or non-admin session — clear it so the login page can render.
  auth.clearSessionPublic();
  return true;
};

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = auth.currentUser();
  if (user?.role === 'admin') return true;

  auth.clearSessionPublic();
  return router.createUrlTree(['/auth/login']);
};
